var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.542969,
    y: 0.09375,
    width: 21.2131,
    height: 21.2131,
    rx: 10.6066,
    fill: "#60EC2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6238 8.60218C14.1824 8.50777 13.7828 8.27486 13.4831 7.93739C13.1834 7.59993 12.9993 7.17556 12.9577 6.72615V6.53125H11.4352V12.5735C11.4342 12.8409 11.3495 13.1014 11.1929 13.3183C11.0363 13.5351 10.8156 13.6975 10.562 13.7825C10.3084 13.8675 10.0345 13.8709 9.77883 13.7922C9.52316 13.7135 9.29859 13.5567 9.13665 13.3438C8.97219 13.1273 8.88097 12.8641 8.8762 12.5922C8.87142 12.3204 8.95336 12.0542 9.11011 11.8321C9.26687 11.6099 9.4903 11.4435 9.748 11.357C10.0057 11.2704 10.2843 11.2682 10.5433 11.3506V9.80382C9.96566 9.72396 9.37747 9.82666 8.86103 10.0976C8.34459 10.3685 7.92575 10.794 7.66308 11.3147C7.4004 11.8353 7.30705 12.4251 7.39606 13.0014C7.48507 13.5778 7.752 14.1119 8.15952 14.529C8.54814 14.9267 9.04644 15.1995 9.59081 15.3127C10.1352 15.4258 10.7009 15.3742 11.2158 15.1644C11.7307 14.9546 12.1714 14.5961 12.4817 14.1347C12.7919 13.6733 12.9576 13.1299 12.9577 12.5739V9.4865C13.5729 9.92638 14.3107 10.1622 15.067 10.1609V8.64814C14.9181 8.64833 14.7695 8.63292 14.6238 8.60218Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.dec544dd2acefbe9f069fdc064a71dfc.svg";
export { ForwardRef as ReactComponent };